import { MDBBtn } from 'mdb-react-ui-kit';
import { useTranslation } from 'react-i18next';
import TopicsDisplay from '../../../components-user/topics/TopicsDisplay';

export default function ProductTopicSection({
  productData,
  topics,
  topicGroups,
  selectedTopics,
  unknownTopicNames,
  toggleSelectTopicsModal,
  handleSetSelectedTopics,
  getFieldError,
  markFieldTouched,
}) {
  const { t } = useTranslation();
  const topicError = getFieldError('cMSProductTopicId');

  return (
    <>
      <p className="text-muted mb-3">
        {t("Select the topic that best describe your product.")}
      </p>
      <MDBBtn
        onClick={() => { markFieldTouched('cMSProductTopicId'); toggleSelectTopicsModal(); }}
        color="primary"
        outline
        size="sm"
      >
        {t("Select Topic")}
      </MDBBtn>
      {topicError && (
        <div className="text-danger small mt-2">{topicError}</div>
      )}
      {topics.length > 0 && topicGroups.length > 0 && productData.cMSProductTopicId && (
        <TopicsDisplay
          topics={topics}
          topicGroups={topicGroups}
          selectedTopics={[productData.cMSProductTopicId]}
          unknownTopicNames={unknownTopicNames}
          onRemoveTopic={(id) => handleSetSelectedTopics(selectedTopics.filter(sid => sid !== id))}
        />
      )}
    </>
  );
}
